import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
import cn from "../../../../utils/cn";
import Divider from "../../../Divider";
const DropdownHeader = ({ children, className }) => (_jsxs(_Fragment, { children: [_jsx("div", { className: cn("flex", className), children: children }), _jsx(Divider, {})] }));
export default memo(DropdownHeader);
